module.exports = __webpack_public_path__ + "6e5ccba500b5057ad2f0172d19666430.jpg";